import React from "react";
import { BarChart3 } from "lucide-react";
import { PageHeading } from "../../components/ui/PageHeading";
import { Card } from "../../components/ui/Card";

/**
 * Placeholder for the Reports module. The sidebar has linked to
 * `/setting/reports` since the wireframe redesign, but no Reports
 * wireframe or backend endpoint has been provided yet — the route simply
 * didn't exist, so clicking it fell through to the app's catch-all route
 * and bounced straight back to Login, which looked like an unexpected
 * logout. This registers a real (if minimal) page so that no longer
 * happens; swap in the real Reports UI once a wireframe/API is available.
 */
const Reports = () => (
  <div className="px-3 sm:px-5">
    <PageHeading title="Reports" />
    <Card className="flex flex-col items-center gap-2 p-10 text-center">
      <BarChart3 className="h-8 w-8 text-slate-300" />
      <p className="text-sm font-medium text-slate-600">Reports are coming soon.</p>
      <p className="max-w-sm text-sm text-slate-400">
        This section isn't built yet — no design or API has been provided for it. In the meantime, batch and
        dispatch data can be exported from the Batch and Dispatch History pages.
      </p>
    </Card>
  </div>
);

export default Reports;
